<template>
  <section>
    <v-row class="my-0">
      <v-col cols="12" md="6">
        <v-card flat>
          <v-card-title class="py-2">{{ $translate('DELIVERY_ADDRESS') }}</v-card-title>
          <v-card-text>
            <div>{{ `${userInfo.firstName} ${userInfo.lastName}` }}</div>
            <div>{{ `${userInfo.street} ${userInfo.houseNo}` }}</div>
            <div>{{ `${userInfo.postalCode} ${userInfo.city}` }}</div>
            <div>{{ `${userInfo.phoneNo}` }}</div>
            <div>{{ `${userInfo.email}` }}</div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card flat>
          <v-card-title class="py-2">{{ $translate('DELIVERY_DATE') }}</v-card-title>
          <v-card-text>
            <div>{{ event.Name }}</div>
            <div class="font-weight-bold">{{ startDate }} {{ `${startTime} - ${endTime}` }}</div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>

<script>
export default {
  name: 'SubscriptionOverviewDelivery',
  components: {},
  props: {
    event: Object,
    userInfo: Object,
    startDate: String,
    startTime: String,
    endTime: String,
  },
  data() {
    return {
    };
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
</style>
